import { render } from "./section1.vue?vue&type=template&id=503ced0a&scoped=true"
import script from "./section1.vue?vue&type=script&lang=js"
export * from "./section1.vue?vue&type=script&lang=js"

import "./section1.vue?vue&type=style&index=0&id=503ced0a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503ced0a"]])

export default __exports__